import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import Chevron from './utility/Chevron';
import DashboardButton from './utility/DashboardButton';
import { handleFireGTM } from '../utility/routeUtil';

const styles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    border: `2px solid ${props.tenant.primary} !important`,

    '&:hover': {
      backgroundColor: 'white !important',
      border: `2px solid ${props.tenant.primary} !important`,
      color: `${props.tenant.primary} !important`,
      borderStyle: 'solid',
    },
  }),
};

class TakeActionLearnMore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chevronColor: 'white',
    };
  }

  displayNone = {
    display: 'none',
  };

  tenantSpecificButtonStyles = {
    backgroundColor: `${this.props.tenant.primary}`,
    color: 'white',
  };

  displayDropdownOptions = (option) => {
    return <div className="dropdown-option">{option.label}</div>;
  };

  determineTakeActionButtonText = (t) => {
    const { userProgress } = this.props;
    if (!userProgress.started_ecap) {
      return t('Create my {{planName}}', {
        planName: 'Education and Career Action Plan',
      });
    }
    if (userProgress.started_ecap && !userProgress.completed_ecap) {
      return t('Continue my {{planName}}', {
        planName: 'Education and Career Action Plan',
      });
    }
    if (userProgress.completed_ecap) {
      return t('View my {{planName}}', {
        planName: 'Education and Career Action Plan',
      });
    }
  };

  displayDashboardButtons = (dashButtons, button) => {
    // for Nevada, we only want to display locations that host the degrees the user has chosen
    let buttonDetails = dashButtons[button];
    if (this.props.tenant.name === 'Nevada' && button === 'button1') {
      buttonDetails = this.createAvailableCampusList(buttonDetails);
    }
    return (
      <DashboardButton
        button={button}
        buttonDetails={buttonDetails}
        key={button}
      />
    );
  };

  createAvailableCampusList = (buttonDetails) => {
    const availableInstitutions = [];

    Object.values(this.props.degreeChoices).map((choice) => {
      return choice.institution_info.forEach((institution) => {
        if (
          availableInstitutions.indexOf(institution.institution_name) === -1
        ) {
          availableInstitutions.push(institution.institution_name);
        }
      });
    });

    return {
      ...buttonDetails,
      childButtons: buttonDetails.childButtons.filter(
        (button) => availableInstitutions.indexOf(button.labelEn) !== -1
      ),
    };
  };

  displayTakeAction = () => {
    return (
      this.props.tenant.features.includes('highschool') &&
      this.props.userInHighSchool
    );
  };

  handleRoutingGTM = () => {
    // Pass next route explicitly
    handleFireGTM(
      this.props.tenant.name,
      'click "ecap" from dashboard',
      this.props.location.pathname,
      '/education-plan'
    );
  };

  render() {
    const dashButtons = {};
    Object.keys(this.props.tenant.buttonInfo).forEach((key) => {
      if (this.props.tenant.buttonInfo[key]) {
        dashButtons[key] = this.props.tenant.buttonInfo[key];
      }
    });
    return (
      <Translation>
        {(t) => (
          <div id="take-action-learn-more">
            {this.displayTakeAction() ? (
              <div className="take-action">
                <h2 className="section-heading">{t('Take Action:')}</h2>
                <div
                  className={
                    Object.keys(dashButtons).length > 0
                      ? 'section-buttons border-right'
                      : 'section-buttons'
                  }
                >
                  <Link to="education-plan">
                    <button
                      type="button"
                      onClick={() => this.handleRoutingGTM()}
                      tabIndex={0}
                      className={`button--primary take-action-learn-more-button ${this.props.classes.color}`}
                      style={this.tenantSpecificButtonStyles}
                      onMouseOver={() => {
                        this.setState({
                          chevronColor: this.props.tenant.primary,
                        });
                      }}
                      onFocus={() => {
                        this.setState({
                          chevronColor: this.props.tenant.primary,
                        });
                      }}
                      onMouseOut={() => {
                        this.setState({
                          chevronColor: 'white',
                        });
                      }}
                      onBlur={() => {
                        this.setState({
                          chevronColor: 'white',
                        });
                      }}
                    >
                      {this.determineTakeActionButtonText(t)}
                      <Chevron color={this.state.chevronColor} hide />
                    </button>
                  </Link>
                </div>
              </div>
            ) : null}
            {Object.keys(dashButtons).length > 0 && (
              <div className="learn-more">
                <h2 className="section-heading">{t('Learn More:')}</h2>
                <div className="section-buttons">
                  {Object.keys(dashButtons).map((button) => {
                    return (
                      <span key={button}>
                        {this.displayDashboardButtons(dashButtons, button)}
                      </span>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const TakeActionLearnMoreWithRouter = withRouter(TakeActionLearnMore);

export default withStyles(styles)(TakeActionLearnMoreWithRouter);
